import { useState, useEffect } from "react";
import { Input } from "./input";
import { DollarSign } from "lucide-react";

// Format number as currency string (without $ sign)
const formatValue = (value) => {
  if (value === "" || value === null || value === undefined) return "";
  const num = typeof value === "string" ? parseFloat(value.replace(/,/g, "")) : value;
  if (isNaN(num)) return "";
  return num.toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
};

// Parse formatted string back to number
const parseValue = (formattedValue) => {
  if (!formattedValue) return 0;
  const cleaned = formattedValue.replace(/[^0-9.]/g, "");
  return parseFloat(cleaned) || 0;
};

export const CurrencyInput = ({ 
  value, 
  onChange, 
  placeholder = "0",
  className = "",
  ...props 
}) => {
  const [displayValue, setDisplayValue] = useState("");

  useEffect(() => {
    setDisplayValue(formatValue(value));
  }, [value]);

  const handleChange = (e) => {
    const input = e.target.value;
    
    // Allow only numbers and commas
    const cleaned = input.replace(/[^0-9,]/g, "");
    
    // Parse and format
    const numericValue = parseValue(cleaned);
    const formatted = formatValue(numericValue);
    
    setDisplayValue(formatted);
    onChange(numericValue);
  };

  const handleBlur = () => {
    // Re-format on blur to ensure proper formatting
    setDisplayValue(formatValue(value));
  };

  return (
    <div className="relative">
      <DollarSign className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
      <Input
        type="text"
        inputMode="numeric"
        value={displayValue}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={placeholder}
        className={`pl-9 ${className}`}
        {...props}
      />
    </div>
  );
};

export default CurrencyInput;
